<template>
	<div class="split-loader">
		<loader v-show="isLoading" :size="loaderSize"></loader>
	</div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
	name: 'SplitLoader',
	components: {
		Loader,
	},
	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		loaderSize: {
			type: Number,
			default: 36,
		},
		windowH: {
			type: Number,
			default: 0,
		},
		index: {
			type: Number,
			default: 0,
		},
		current: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			isTouched: false,
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onWindowScroll);
	},
	computed: {
	},
	methods: {
		onWindowScroll: function(e) {
			//this.$utils.log('SplitLoader scroll');
			if (this.index !== this.current) {
				// 複数ローダー対応
				// 自身のローダーでない場合はスルー
				return;
			}

			let loaderTop = document.getElementsByClassName('split-loader')[this.current].getBoundingClientRect().top;

			if (this.windowH >= loaderTop) {
				if (!this.isTouched) {
					this.onBaseTouch();
				}
			} else {
				this.isTouched = false;
			}
		},
		onBaseTouch: function() {
			this.isTouched = true;
			this.$emit('base-touch', this.index);
		},
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onWindowScroll);
	},
}
</script>

<style lang="scss">

</style>
